/**
 * Created by rlopez on 10/11/16.
 */
// ConnectionDetailsView.js//
//
import $ from 'jquery';
import {Model} from 'backbone';
import RestService from 'RestService.js';
import constants from 'Constants.js';
import SelectItemModalView from 'common-views/SelectItemModalView.js';
import SimpleConfirmModalView from 'common-views/SimpleConfirmModalView.js';
import SelectFormOrReportModalView from 'common-views/SelectFormOrReportModalView.js';
import undoService from 'UndoService.js'
import textConstants from 'TextConstants';
import xjService from 'xml/XJService';
import zLib from 'util/ZLib';
import eventBus from 'EventBus';
import notificationService from 'NotificationService';
import _ from 'lodash';
import util from 'util/Util';
import listService from 'ListService.js'; 
import ConnectionDashboardController from 'ConnectionDashboardController'; 
import Spinner from 'spin/spin';
import MigrateConnectionModal from 'dashboard/forms/modal/MigrateConnectionModal';
import SelectFileModal      from 'common-views/SelectFileModal.js';
import restService from '../../../service/RestService';
import restMessages from 'RestMessages';



class ConnectionService {

    constructor(opts){
        this.model = opts.model;
    }

    updatePermissions(ev){
        $('#permissionTypes input[type="checkbox"]').prop('disabled',false).prop('checked',false);
        let currentModel=this.model.get('currentConnectionDetails');
        let selectedUser=currentModel.PermissionsXML.filter((user=>{
            return user['@caption'] === ev.currentTarget.value;
        }))[0];
        selectedUser.Permission = selectedUser.Permission instanceof Array ? selectedUser.Permission : [selectedUser.Permission];
        if(selectedUser.Permission[0]){
            selectedUser.Permission.forEach((permission)=>{
                switch (permission['@type']){
                    case 'report':
                        this.checkPermission(permission['#text'],'#useAllow','#useDeny');
                        break;
                    case 'edit':
                        this.checkPermission(permission['#text'],'#editAllow','#editDeny');
                        break;
                    case 'administer':
                        this.checkPermission(permission['#text'],'#fullAllow','#fullDeny');
                        break;
                }

            });
        }

        $('#removePermission').attr('disabled', false);
        this.model.set('selectedPermission',ev.currentTarget.value,{silent:true});
    }

    processConnectionCheckboxes(ev) {
        let currentModel = this.model.get('currentConnectionDetails');
        currentModel.ConnectionXML.Connection[ev.target.name] = ev.target.checked ? 'true' : 'false';
        this.model.set('currentConnectionDetails', currentModel, { silent: true });
        this.model.set('hasChanges', true);
    }

    processConnectionInputs(ev) {
        let currentModel = this.model.get('currentConnectionDetails');        
        if (ev.target.id === 'fileName'){            
            let fileId = $( "#fileName option:selected" ).val();
            let fileName = $( "#fileName option:selected" ).text();
            currentModel.ConnectionXML.Connection['_fileId'] = fileId;
            currentModel.ConnectionXML.Connection['_fileName'] = fileName;
        }else{

            if(ev.target.id === 'cert-file-upload'){              
                let fileName = ev.target.value.split( '\\' ).pop();
                currentModel.CertificateName = fileName;
                currentModel.CertificateFile = this.certificateFile;
                currentModel.ClearCertificate = 'false';
            }else{
                if(ev.target.id === 'cert-file-upload-label'){
                    currentModel.ClearCertificate = 'true';
                    currentModel.CertificateName = '';
                    currentModel.CertificateFile = '';
                }else{
                    if(ev.target.name === "CertificatePassphrase"){
                        currentModel.CertificatePassphrase = ev.target.value;
                    }else{
                        currentModel.ConnectionXML.Connection[ev.target.name] = ev.target.value;
                    }
                }
            }
        }
        this.model.set('currentConnectionDetails', currentModel, { silent: true });
        this.model.set('hasChanges', true);
        if (ev.target.name === '_username') {
            $('#getToken').prop('disabled', false);
        }
    }

    changeConnectionName(ev) {
        let currentModel = this.model.get('currentConnectionDetails');
        currentModel.ConnectionXML.Connection['_name'] = ev.target.value;
        
        // PF-5944 Validate if value actually change (for keyup event)
        if (currentModel.Name !== ev.target.value){
            currentModel.Name = ev.target.value;
            this.model.set('currentConnectionDetails', currentModel, { silent: true });
            this.model.set('hasChanges', true, {silent: true});

            // Show apply changes
            $('#actionsSection').addClass('hide');
            $('#changesSection').removeClass('hide');
        }
        
    }

    changeConnectionStatus(ev) {
        let currentModel = this.model.get('currentConnectionDetails');
        currentModel.ConnectionXML.Connection['_active'] = ev.target.checked ? 'true' : 'false';
        currentModel.IsActive = ev.target.checked ? 'True' : 'False';
        this.model.set('currentConnectionDetails', currentModel, { silent: true });
        this.model.set('hasChanges', true);
    }

    checkConnection(){
        let currentModel = this.model.get('currentConnectionDetails'),
            _username = currentModel.ConnectionXML.Connection['_username'],
            _password = currentModel.ConnectionXML.Connection['_password'],
            _url=currentModel.ConnectionXML.Connection['_url'];
        let connectionObject={
            _username,
            _password,
            _url
        };

        return new Promise((resolve, reject) => {
            if (currentModel.ConnectionXML.Connection['_useProxy'] === 'true') {
                RestService.checkConnection(connectionObject).then((results) => {
                    if (this.checkDatabaseResponseForErrors(results)) {   
                        notificationService.success('Connection success');

                        resolve(xjService.toJSON(results.RESULT.RESPONSE['#cdata-section']));
                    }
                    else {
                        reject();
                    }
                }).catch((err) => {
                    let errToDisplay = "";

                    if ($.type(err) === 'string') {
                        errToDisplay = err;
                    }
                    else {
                        errToDisplay = err.MESSAGE['#cdata-section'] || err.MESSAGE || err;

                        // overwrite previews error since it may be a full 404 page like 
                        if (errToDisplay.length > 512) {
                            errToDisplay = "An error has occurred. Agent communication error"
                        }
                    }
                     
                        // Show a success message
                    $('<div></div>').dialog({
                        modal: true,
                        title: "Connection error",
                        open: function () {
                            $(this).html(errToDisplay);
                        },
                        buttons: {
                            Ok: function () {
                                $(this).dialog("close");
                            }
                        }
                    }); 
                
                    try {
                        console.log('Error on Making the Web Service Call', err);
                        //notificationService.error('Agent communication error ' + err.MESSAGE['#cdata-section'] || err.MESSAGE || err);
                    }
                    catch (err) { }

                    reject();
                });
            }
            else {
                RestService.getResourcesList(connectionObject).then((results) => {
                    if (results) {
                        notificationService.success('Connection success');

                        resolve(xjService.xmlDocToJs(results));
                    }
                    else {
                        reject();
                    }
                }).catch((jqXHR, textStatus, errorThrown) => {
                    let errToDisplay = "";
                    
                    if ($.type(jqXHR) === 'string') {
                        errToDisplay = jqXHR;
                    }
                    else {
                        try {
                            errToDisplay = jqXHR.responseJSON.message;
                        }
                        catch (ex) {
                            errToDisplay = "An error has occurred. Agent communication error";   
                        }                     

                        // overwrite previews error since it may be a full 404 page like 
                        if (errToDisplay.length > 512) {
                            errToDisplay = "An error has occurred. Agent communication error";
                        }
                    }
                    
                    // Show a success message
                    $('<div></div>').dialog({
                        modal: true,
                        title: "Connection error",
                        open: function () {
                            $(this).html(errToDisplay);
                        },
                        buttons: {
                            Ok: function () {
                                $(this).dialog("close");
                            }
                        }
                    }); 

                    try {
                        console.log('Error on Making Resources List Call', jqXHR.responseJSON.message);
                        //notificationService.error('Error on Making Resources List Call ' + jqXHR.responseJSON.message);
                    }
                    catch (err) { }
                    
                    reject();
                });
            }
        });    
    }

    checkDatabaseResponseForErrors(response) {
        // Null response, or error code means we have an error
        if (!response || !response.RESULT || response.RESULT.ERROR.CODE !== '0') {
            return false;
        }

        let responseBody = xjService.toJSON(response.RESULT.RESPONSE['#cdata-section']);

        // Error received from Connection Agent or Service called        
        if (responseBody.response.error && responseBody.response.error.$) {
            //notificationService.error(responseBody.response.error._message);
            $('<div></div>').dialog({
                modal: true,
                title: "Connection error",
                open: function () {
                    $(this).html(responseBody.response.error._message);
                },
                buttons: {
                    Ok: function () {
                        $(this).dialog("close");
                    }
                }
            });
            return false;
        }

        return true;
    }

    checkPermission(permission,allowSelector,denySelector){
        if(permission === 'allow'){
            $(allowSelector).prop('checked',true);
            $(denySelector).prop('checked',false);
        }
        else if(permission === 'deny'){
            $(allowSelector).prop('checked',false);
            $(denySelector).prop('checked',true);
        }
    }

    convertToXMLAndCompress(connectionObject){
        const XMLObject = xjService.toXML(connectionObject);
        return zLib.compressForm(XMLObject);
    }

    selectForm(){
        let selectFormOrReportModal = new SelectFormOrReportModalView({
            model: new Model(),
            mode: 'form',
            checkForInstances: false
        });
        selectFormOrReportModal.render().then((selectedForm)=>{
            if(selectedForm){
                let currentModel=this.model.get('currentConnectionDetails');
                currentModel.ConnectionXML.Connection._formId=selectedForm.id;
                currentModel.ConnectionXML.Connection._formName=selectedForm.name;
                currentModel.ConnectionXML.Connection._formGUID=selectedForm.GUID;
                this.model.set('currentConnectionDetails',currentModel,{silent:true});
                this.model.set('hasChanges',true);
            }
        })
    }

    applyChanges() {
        const currentModel = this.model.get('currentConnectionDetails');

        //Always set the XML connection ID to the model connection ID to avoid issues with export/import
        currentModel.ConnectionXML.Connection._id = this.model.get('connectionId');
      
        const updateParameters={
            connectionId:this.model.get('connectionId'),
            name:currentModel.Name,
            type:currentModel.Type,
            isActive:currentModel.IsActive,
            connectionXML:this.convertToXMLAndCompress(currentModel.ConnectionXML),
            permissionsXML:this.formatPermissionsForResponse(currentModel.PermissionsXML),
            permissionsToActions:currentModel.permissionsToActions,
            certificateName:currentModel.CertificateName,
            certificatePassphrase:currentModel.CertificatePassphrase,
            wsdlFileName:currentModel.WsdlFileName,
            wsSourceId:this.model.get("selectedSource")
        };

        //PF-10915 If it has a WSDL file
        if (typeof currentModel.wsdlFile !== 'undefined' && currentModel.wsdlFile !== ''){
            updateParameters.wsdlFile = this.wsdlFile;
        }

         //PF-10860 If it has a certificate file
         if (typeof currentModel.CertificateFile !== 'undefined' && currentModel.CertificateFile !== ''){
            updateParameters.certificateFile = this.certificateFile;
        }


        const originalModel = this.model.get('connectionDetails');
        const originalParamenters = {
            connectionId:this.model.get('connectionId'),
            name:originalModel.Name,
            type:originalModel.Type,
            isActive:originalModel.IsActive,
            connectionXML:this.convertToXMLAndCompress(originalModel.ConnectionXML),
            permissionsXML:this.formatPermissionsForResponse(originalModel.PermissionsXML)
        };

        undoService.add({
            undo: () => {
                this.persistData(originalParamenters);
            },
            redo: () => {
                this.persistData(updateParameters);
            }
        }, textConstants.UNDO_UPDATE_CONNECTION);

        this.persistData(updateParameters);
        util.setUndoRedoAccess();

    }

    persistData(updateParameters){
        // // Saving Changes made on the form.
        RestService.updateConnection(updateParameters).then((data)=> {
            console.log('updated Connection');
            console.log(data);

            eventBus.trigger(constants.EV_UPDATE_CONNECTION_DETAILS,{
                id: this.model.get('connectionId'),
                type:updateParameters.type
            });

        }).catch((err)=> {
            let errMsg = restMessages.codeToMessage(err.CODE);
            console.log(errMsg + '. ' + err);
            console.log('Error on update');
            notificationService.error('Error Loading License Information. ' + errMsg);
        });
    }

    cancelChanges() {        
        this.model.set('currentConnectionDetails',$.extend(true, {}, this.model.get('connectionDetails')),{silent:true});
        this.model.unset('selectedPermission', { silent: true });
        this.model.set('hasChanges', false);
    }

    formatPermissionsForResponse(permissionsParam) {
        let permissionsOpeningTag = '<Permissions>';
        let permissionsClosingTag = '</Permissions>';
        let permissions = permissionsParam;
        
        if(!permissions){
            permissions = []
        }

        let permissionList = permissions.reduce((accum, elem)=> {
            let defaultId='>';
            if(!(elem['@type'] === 'world' || elem['@type'] === 'everyone')){
                defaultId=` id="${elem['@id']}">`;
            }
            let userXML=accum + `<User type="${elem['@type']}"`+ defaultId;
            let permissions=elem.Permission instanceof Array ? elem.Permission:[elem.Permission];
            permissions.forEach(permission=>{
                userXML=userXML+
                    `<Permission type="${permission ? permission['@type'] : "view"}">` +
                    `${permission ? permission['#text'] : "allow"}` +
                    `</Permission>`
            });
            userXML=userXML + `</User>`;
            return userXML;
        }, '');
        permissionList = permissionsOpeningTag + permissionList + permissionsClosingTag;
        console.log('CurrentSendPermissionsBeforeReplacing', permissionList);
        permissionList = permissionList.replace(/</g, '&lt;').replace(/>/g, '&gt;');
        console.log('CurrentSendPermissions', permissionList);
        return permissionList;
    }

    addPermission(ev) {
        ev.preventDefault();

        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));

        setTimeout(() => {
            RestService.browseAllUsers().then((usersData) => {
                let users = [];
                let userAccum = [];
                userAccum.push(this.createUserSpecialItem('Everyone', constants.CONNECTION_ACTION_EVERYONE_PERMISSION_ID.toString()));

                if (usersData.AllUsers.User) {
                    users = _.union(userAccum, util.enforceArrayType(usersData.AllUsers.User));
                }

                let items = users.map((item) => {
                    return {
                        label: item['@caption'],
                        listType: item['@type'],
                        items: item
                    }
                });

                let self = this;
                let permissionView = new SelectItemModalView({ model: new Model({ items: items, infiniteScrolling: constants.INFINITE_SCROLL_ENABLED }), spinner:spinner });
                permissionView.render().then(selectedItem => {
                    let modelUpdated = false;
                    if (selectedItem) {
                        let currentModel = this.model.get('currentConnectionDetails');
                        let currentPermissionList;

                        if (currentModel.PermissionsXML) {
                            // Checking if the permission selected is not already present in the current list.
                            currentPermissionList = currentModel.PermissionsXML;
                            let permissionsChanged = currentPermissionList.filter((permission) => {
                                return permission['@id'] === selectedItem.items['@id'];
                            });

                            if (permissionsChanged.length === 0) {
                                selectedItem.items.Permission = [];
                                currentPermissionList.push(selectedItem.items);
                                currentModel.PermissionsXML = currentPermissionList;
                                modelUpdated = true;
                            }
                        }
                        else {
                            currentPermissionList = [];
                            selectedItem.items.Permission = [];
                            currentPermissionList.push(selectedItem.items);
                            currentModel.PermissionsXML = currentPermissionList;
                            modelUpdated = true;
                        }

                        if (modelUpdated) {
                            self.model.set('currentConnectionDetails', currentModel, { silent: true });
                            self.model.set('hasChanges', true, { silent: true });
                            self.model.set('permissionsChanged', true, { silent: true });
                            this.model.trigger('change');
                            $(`select[name='permissions']`).val(selectedItem.label).change();
                        }
                    }
                }).catch((errMsg) => {
                    console.log(errMsg);
                    notificationService.error(errMsg);
                });
            });
        }, 10);
    }

    createUserSpecialItem(name, id){
        return {'@type': `${name.toLowerCase()}`, '@id': id ? id : '-2147483524', '@caption': `${name}`};
    }

    removePermission(ev) {
        ev.preventDefault();
        let selectedPermission = $(`select[name='permissions']`).val();
        let currentModel=this.model.get('currentConnectionDetails');

        // Checking if the permission selected is not already present in the current list.
        let currentPermissionList = currentModel.PermissionsXML;
        let currentPermissionListWithRemovedElement = currentPermissionList.filter((permission)=> {
            return permission['@caption'] !== selectedPermission;
        });
        if (currentPermissionListWithRemovedElement.length < currentPermissionList.length) {
            currentModel.PermissionsXML=currentPermissionListWithRemovedElement;
            this.model.set('currentConnectionDetails', currentModel,{silent:true});
            this.model.set('hasChanges', true, {silent: true});     
            this.model.set('permissionsChanged', true, { silent: true });       
            this.model.unset('selectedPermission', {silent: true});
            this.model.trigger('change');
        }
    }

    deleteConnection(ev) {
        let params = listService.connectionItemSelected;
        let simpleModal = util.createDialogDeleteConfirmation("Delete Connection", `Are you sure you want to delete the connection ${params.name}?`);
      
        simpleModal.render().then((result)=>{
            if (result === 'Ok') {
                ConnectionService.makeDeleteConnection(params.connectionId, params.connectionType);
                listService.connectionItemSelected = undefined;
            }
        }).catch((err)=> {
            console.log('Error Showing Delete List Confirmation Message', err);
            notificationService.error('Error Showing Delete List Confirmation Message' + err.MESSAGE);
        });
    }    

    static makeDeleteConnection(connectionId, connectionType, addUndoService = true){
        let self = this;
        RestService.deleteConnection(connectionId).then((response) => {
           
            eventBus.trigger(constants.EV_DELETE_CONNECTION, connectionType);

            if (addUndoService) {
                undoService.add({
                    undo: () => {                        
                        ConnectionDashboardController.undeleteConnection(listService.dashboardLayout.leftPanelView, connectionId, connectionType);                               
                    },                        
                    redo: () => {
                        ConnectionDashboardController.redoDeleteConnection(connectionId, connectionType);
                    }
                }, textConstants.UNDO_DELETE_CONNECTION);

                util.setUndoRedoAccess();
            }
             
        }).catch((err)=> {
            console.log('Error Deleting Connection', err);
            notificationService.error(`Error Deleting Connection. ${err.MESSAGE}`);
        });
    }

    migrate() {

        const migrateConnectionModal = new MigrateConnectionModal({ model: new Model( {"warning": false})} );
        migrateConnectionModal.settings.width = 400;
        migrateConnectionModal.render().then(importType => {
            if (importType && importType !== 'Unauthorized') {

                switch (importType) {
                    case 'import':
                        const selectFileModal = new SelectFileModal();
                        selectFileModal.settings.width = 400;
                        selectFileModal.render().then(selectedFile => {

                            if (selectedFile !== "Unauthorized") {
                                const warningModal = new MigrateConnectionModal({ model: new Model({ "warning": true }) });
                                warningModal.settings.width = 400;
                                warningModal.render().then(result => {

                                    if (result !== "noBackup") {
                                        this.performMigrate();
                                    }

                                    this.performImport(selectedFile);

                                });
                            }
                        });
                        break;
                    case 'export':
                        let simpleConfirmModal = new SimpleConfirmModalView(
                            {
                                model: new Model({
                                    confirmationDialog: 'Migrate',
                                    confirmationText: 'Migrate Connections and all its Actions?',
                                    height: 'auto',
                                    width: 400
                                })
                            });
                        simpleConfirmModal.render().then((result) => {
                            if (result === 'Ok') {
                                this.performMigrate();
                            }
                        }).catch((err) => {
                            console.log('Error Applying changes on Migration', err);
                            notificationService.error('Error Applying changes on Migration' + err.MESSAGE);
                        });
                        break;
                }
            }
        });
    }

    performImport(file) {
        let connectionId = this.model.get('connectionId');
        let connectionType = this.model.get('connectionType');
        restService.importFile(file.name, file.file, connectionId, "connection", true).then(
            (result) => {
                //Process dependencies
                let dependencies = 'None';
                let importedConnection = result.RESULT.RESPONSE;
                if(importedConnection.Dependencies && importedConnection.Dependencies.Dependency){
                    const deps = Array.isArray(importedConnection.Dependencies.Dependency) ? importedConnection.Dependencies.Dependency : [importedConnection.Dependencies.Dependency];
                    dependencies = '</br>';
                    for (let i = 0; i < deps.length; i++) {
                        dependencies += ' - ';
                        dependencies += deps[i]["@type"].charAt(0).toUpperCase() + deps[i]["@type"].slice(1);
                        dependencies += ' "' + deps[i]["@caption"] + '" : ';
                        dependencies += util.isTrue(deps[i]["@found"])?'OK </br>':'Missing </br>';
                    }
                }

                //We refresh the connection's left tree and the connections detail view
                ConnectionDashboardController.expandUpdatedConnectionListAndDetailView(listService.dashboardLayout.leftPanelView, connectionId, connectionType);
                const selectFileModal = new SelectFileModal({ title: 'Import', itemName: importedConnection.caption, dependencies: dependencies });
                selectFileModal.settings.width = 400;
                selectFileModal.render();
            }, 
            (errMsg) => {
                if (errMsg.RESULT.ERROR.CODE === '67' || errMsg.RESULT.ERROR.CODE === '999') {
                    let content = '';

                    if (errMsg.RESULT.ERROR.CODE === '67'){
                        content = 'The import file does not contain the required item type.';
                    }else{
                        content = 'The selected file type is not supported. ' +
                        'Apps and reports created in 4.x or earlier versions cannot be imported currently.';
                    }

                    const selectFileModal = new SelectFileModal({
                        title: 'Import',
                        itemName: content, dependencies: 'None',
                        width: 450,
                        message: "Import Failed."
                    });
                    selectFileModal.render();

                    notificationService.error('File was not imported succesfully');
                }
                else {
                    notificationService.error(errMsg.RESULT.ERROR);
                }
            });
    }

    performMigrate(){
        RestService.exportFormResponseData(this.model.get('connectionId'),
            'c',
            this.model.get('currentConnectionDetails').Name);
    }

    newAction(){
        eventBus.trigger(constants.EV_ADD_ACTION, this.model.get('connectionId'), this.model.get('connectionType')); 
    }

    connectAuthSub(ev){
        let username = $('input[name=_username]').val();
        let password = $('input[name=_password]').val();
 
        if( (!username || username === '') ||
            (!password || password === '') ){
            return;
        }

        RestService.connectAuthSub(username,password).then((response)=>{
            console.log(response);
        }).catch((err)=> {
            notificationService.error('Error Getting Sheets ' + err.MESSAGE);
        });
    }

    validateCertificateExpiration(){

        const certificateExpiresOn = this.model.get("currentConnectionDetails").CertificateExpiresOn;

        if(certificateExpiresOn && certificateExpiresOn !== '' && typeof certificateExpiresOn !== 'undefined'){
            this.model.set("expired", "notExpired", {silent:true});

            const expiration = new Date(certificateExpiresOn);
            const today = new Date();

            if (expiration < today) {
                this.model.set("expired", "certificateExpired", {silent:true});
            }
        }
    }

    loadCertificateFileUpload(){
        const self = this;
        let file = $('#certificateFile');
           
        $('#cert-file-upload').on('change', (e) => {
            self.certificateFile = $('#cert-file-upload')[0].files[0];
            file.val(e.target.value.split( '\\' ).pop());
            self.processConnectionInputs(e);
        });

        $("#CertificatePassphrase").on("focus",(e)=>{
            $("#CertificatePassphrase").val("");
        });

        $("#remove-file").on('click', (e)=>{
           let confirmation = util.createDialogDeleteConfirmation("Remove Certificate",
            "Are you sure you wish to remove the certificate for this connection?",
            true);

            confirmation.render().then((result) => {
                if (result === 'Ok') {
                    file.val("");                   
                    self.processConnectionInputs(e); 
                    $(".certificateDate").html("");
                    $("#CertificateName").val("");
                    $("#CertificatePassphrase").val("");                }
            });
        })
    }
   
    loadWSSources(refresh){
        const self = this;

        return new Promise(resolve => {

            if (!this.model.get("wsSources") || refresh) {
                RestService.getWSSources().then((response) => {                    
                   
                    if (response && response !== "") {
                        
                        let data = [];

                        if(response.WSSourcesList.WSSource){
                            data = response.WSSourcesList.WSSource;
                        }                
                        if (!Array.isArray(data)) {
                            data = [data];
                        }

                        console.log("WS Sources loaded");
                        self.model.set("wsSources", data, { silent: true });
                        self.model.set("selectedSource", self.model.get("connectionDetails").WSSourceId, {silent:true});

                        resolve(true);
                    }
                }).catch((err => {
                    resolve(false);
                    console.log('Error WS Sources', err);
                    notificationService.error('Error Loading WS Sources Data' + err.MESSAGE);
                }));
            }
        });
    }

    setNewSource(ev){
        ev.preventDefault();
        const selected = ev.currentTarget;
        const text = selected.options[selected.selectedIndex].text;      
        
        this.model.set("selectedSource", selected.value, {silent:true});
        $("input[name=_url]").val(text);
        $("input[name=_url]").trigger("change");
    }

    associateToSource(){
        const isBULicense = util.isTrue(listService.accountSettings.IsBULicense);
        const currentConnectionDetails = this.model.get("currentConnectionDetails");

        if(isBULicense){

            const cURL = currentConnectionDetails.ConnectionXML.Connection['_url'];
            const urlEmpty = !cURL || cURL === '' || cURL === 'undefined';
            const selectedSource = this.model.get("selectedSource");

            //if the selected source is empty but there is an url in the connection XML check if it needs to be associated
            if((!selectedSource || selectedSource === "") && !urlEmpty){
                const inCatalog = this.model.get("wsSources").find(function(source) {return source['@Source'] === cURL});
                if(inCatalog){
                    this.model.set("selectedSource", inCatalog["@WsSourceId"], {silent:true});
                    this.model.set('hasChanges', true, {silent: true});
                }

            }           
        }
    }
    
}

export default ConnectionService;

